import { render, staticRenderFns } from "./suggestInput.vue?vue&type=template&id=35a7981e&scoped=true"
import script from "./suggestInput.vue?vue&type=script&lang=js"
export * from "./suggestInput.vue?vue&type=script&lang=js"
import style0 from "./suggestInput.vue?vue&type=style&index=0&id=35a7981e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a7981e",
  null
  
)

export default component.exports